// 设置状态值;
export default {
   state : {
    menuType: '', // 菜单类型 project/company/people... 用于切换弹窗
    count: '',
    islogin: false,//是否登录
    user_unique_key: '',//
    access_token: "",//
    user_guid: '',//用户id
    isExpert:false,//是否是专家
    isTest: true,//true是测试服 ， false是正式服
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js